import React from 'react';
import PropTypes from 'prop-types';

class MessagePending extends React.PureComponent {
    static propTypes = {
        message: PropTypes.string.isRequired,
    };

    render() {
        const { message } = this.props;

        return (
            <p>
                <i className="fa fa-clock-o" aria-hidden />
                {` ${message}`}
            </p>
        );
    }
}

export default MessagePending;
